import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import FormatItalic from "@mui/icons-material/FormatItalic";
import FormatBold from "@mui/icons-material/FormatBold";
import FormControl from "@mui/joy/FormControl";
import Check from "@mui/icons-material/Check";
import IconButton from "@mui/joy/IconButton";
import FormLabel from "@mui/joy/FormLabel";
import MenuItem from "@mui/joy/MenuItem";
import Textarea from "@mui/joy/Textarea";
import { Button } from "@mui/material";
import Menu from "@mui/joy/Menu";
import Box from "@mui/joy/Box";
import React from "react";
import axios from "axios";

const URL = process.env.REACT_APP_BACKEND_URL;
export default function TextArea({
  email,
  name,
  subject,
  setName,
  setEmail,
  setSubject,
}) {
  const [fontWeight, setFontWeight] = React.useState("normal");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState({ success: false, message: "" });
  const [emailText, setEmailText] = React.useState();
  const [italic, setItalic] = React.useState(false);

  const sendEmail = async () => {
    setLoading(true);
    try {
      const data = {
        email,
        subject,
        name,
        emailText,
      };
      const res = await axios.post(URL + "/receive-email", data);
      setMessage({ success: true, message: res.data.message });
      setEmailText("");
      setEmail("");
      setName("");
      setSubject("");
      setLoading(false);
    } catch (error) {
      setMessage({ success: false, message: error.response.data.message });
      setLoading(false);
    }
  };
  return (
    <FormControl>
      <FormLabel sx={{ color: message.message ? (message.success ? "#0ef" : "#f00") : "#fff" }}>
        {message.message || "Your Message"}
      </FormLabel>
      <Textarea
        placeholder="Type something here…"
        minRows={3}
        className="!min-w-full"
        onChange={(e) => setEmailText(e.target.value)}
        value={emailText}
        endDecorator={
          <Box
            sx={{
              display: "flex",
              gap: "var(--Textarea-paddingBlock)",
              pt: "var(--Textarea-paddingBlock)",
              borderTop: "1px solid",
              borderColor: "divider",
              flex: "auto",
            }}
          >
            <IconButton
              variant="plain"
              color="neutral"
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <FormatBold />
              <KeyboardArrowDown fontSize="md" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              size="sm"
              placement="bottom-start"
              sx={{ "--ListItemDecorator-size": "24px" }}
            >
              {["200", "normal", "bold"].map((weight) => (
                <MenuItem
                  key={weight}
                  selected={fontWeight === weight}
                  onClick={() => {
                    setFontWeight(weight);
                    setAnchorEl(null);
                  }}
                  sx={{ fontWeight: weight }}
                >
                  <ListItemDecorator>
                    {fontWeight === weight && <Check fontSize="sm" />}
                  </ListItemDecorator>
                  {weight === "200" ? "lighter" : weight}
                </MenuItem>
              ))}
            </Menu>
            <IconButton
              variant={italic ? "soft" : "plain"}
              color={italic ? "primary" : "neutral"}
              aria-pressed={italic}
              onClick={() => setItalic((bool) => !bool)}
            >
              <FormatItalic />
            </IconButton>
            <Button
              size="small"
              variant="contained"
              disabled={loading || !email || !name || !subject || !emailText}
              sx={{ ml: "auto" }}
              onClick={sendEmail}
            >
              {loading
                ? loading && "Sending..."
                : !email || !name || !subject || !emailText
                  ? "Fill Form"
                  : "Send"}
            </Button>
          </Box>
        }
        sx={{
          minWidth: 300,
          fontWeight,
          fontStyle: italic ? "italic" : "initial",
        }}
      />
    </FormControl>
  );
}
